import { DetailsItem, Grid, SeoTags } from 'components';
import { DetailsHeader } from 'components/details-item/DetailsHeader';
import { Loading, loadingStyles } from 'components/loading';
import { getSrc } from 'gatsby-plugin-image';
import { FormattedMessage, useIntl } from 'gatsby-plugin-react-intl';
import { useImages, usePrismicDestination } from 'hooks';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { message } from './styles/ProjectDistrapPage.styles';

export const PROJECT_DISTRAP_UID = 'project-distrap';

export const ProjectDistrapPage: React.FC = () => {
  const { locale, formatMessage } = useIntl();
  const { headerImage } = useImages();
  const { document, loading } = usePrismicDestination(
    locale,
    PROJECT_DISTRAP_UID,
  );

  const seoTags = (
    <SeoTags
      title={formatMessage({ id: 'project-distrap.seo.title' })}
      description={formatMessage({ id: 'project-distrap.seo.description' })}
      imagePath={document?.node.image?.url || getSrc(headerImage)}
    />
  );

  if (loading) {
    return (
      <>
        {seoTags}
        <div css={loadingStyles.loadingWrapper}>
          <Loading />
        </div>
      </>
    );
  }

  if (!document) {
    return (
      <>
        {seoTags}
        <Grid type="page">
          <p css={message}>
            <FormattedMessage id="project-distrap.error" />
          </p>
        </Grid>
      </>
    );
  }

  return (
    <>
      {seoTags}
      <DetailsHeader document={document} path="project-distrap" />
      <DetailsItem>
        <RichText render={document.node.content} />
      </DetailsItem>
    </>
  );
};
